import { api } from "@/api";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { ArticuloTransferencia } from "@/shared/types/articulo-transferencia";
import { sleep } from "@/shared/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";

export async function deleteArticuloTransferencia(id: string): Promise<ArticuloTransferencia> {
    await sleep(1000);
    const response = await api.delete("articulo_transferencias/" + id);
    return response.data;
}

export function useDeleteArticuloTransferenciaMutation(id: string, mutationConfig: MutationConfig<ArticuloTransferencia> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: async () => await deleteArticuloTransferencia(id),
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["articulo_transferencias"] });
        },
    })
}

export interface DeleteArticuloTransferenciaMutationProps{
    id: string, 
    mutationConfig?: MutationConfig<ArticuloTransferencia>,
    children?:(mutationResult:MutationResult<ArticuloTransferencia>)=>ReactNode
}

export function DeleteArticuloTransferenciaMutation({
    id,
    children,
    mutationConfig
}:DeleteArticuloTransferenciaMutationProps){
    const mutationResult = useDeleteArticuloTransferenciaMutation(id, mutationConfig);
    return children&&children(mutationResult)
}